/* eslint-disable @typescript-eslint/no-explicit-any */
export const setQueryParamsToUrl = (params: Record<string, any>) => {
  const queryParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      queryParams.set(key, String(value));
    }
  });

  const hash = window.location.hash;
  const newUrl = `${window.location.pathname}?${queryParams.toString()}${hash}`;
  window.history.replaceState({}, "", newUrl);
};

export const getQueryParamsFromUrl = (): Record<string, string> => {
  const searchParams = new URLSearchParams(window.location.search);
  const result: Record<string, string> = {};

  searchParams.forEach((value, key) => {
    result[key] = value;
  });

  return result;
};
